import React, { useState, useEffect } from 'react';
import AdminTable from 'common/AdminTable';
import TruncatedMessage from 'common/TruncatedMessage';
import { getRequest, deleteRequest } from 'apis/ApiInstence';
import { FaTrash, FaEdit } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const BACKEND = process.env.REACT_APP_BACKEND;

const GiftProductList = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const res = await getRequest('gift-products');
      setData(res?.data || []);
    } catch (err) {
      console.error('Failed to fetch gift products:', err);
      toast.error(err?.message || 'Failed to fetch gift products.');
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleRemove = async (id) => {
    if (!id) return;
    if (!window.confirm('Are you sure you want to delete this gift product?')) return;
    try {
      await deleteRequest(`gift-products/${id}`);
      fetchData();
    } catch (err) {
      console.error('Failed to delete gift product:', err);
    }
  };

  const parseImages = (val) => {
    if (!val) return [];
    try { return JSON.parse(val); } catch { return []; }
  };

  const tableHeaders = [
    {
      Header: 'Image',
      accessor: 'images',
      Cell: ({ row }) => {
        const list = parseImages(row.original.images);
        if (list.length === 0) return <span>No Image</span>;
        return (
          <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
            {list.map((img, i) => (
              <img key={i} src={`${BACKEND}uploads/${img}`} alt={`img-${i}`} width={50} height={50} style={{ objectFit: 'cover', borderRadius: 4 }} />
            ))}
          </div>
        );
      }
    },
    { Header: 'Name', accessor: 'name' },
    { Header: 'Price', accessor: 'selling_price' },
    { Header: 'Original', accessor: 'original_price' },
    { Header: 'Stock', accessor: 'stock_quantity' },
    { Header: 'Type', accessor: 'giftbox_type' },
    { Header: 'Rating', accessor: 'rating' },
    { Header: 'Status', accessor: 'status' },
    {
      Header: 'Description',
      accessor: 'description',
      Cell: ({ row }) => <TruncatedMessage text={row?.original?.description} maxLength={10} />
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button
            className="btn btn-sm mx-1 text-white"
            style={{ backgroundColor: '#ffc107' }}
            onClick={() => navigate(`/gift-products/update/${row.original.id}`)}
          >
            <FaEdit />
          </button>
          <button
            className="btn btn-sm mx-1 text-white"
            style={{ backgroundColor: '#dc3545' }}
            onClick={() => handleRemove(row.original.id)}
          >
            <FaTrash />
          </button>
        </>
      )
    }
  ];

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Gift Product List</h4>
      </div>
      <div className="mx-4">
        {data?.length ? (
          <AdminTable tableHeaders={tableHeaders} tableData={data} />
        ) : (
          <p>No gift products available.</p>
        )}
      </div>
    </div>
  );
};

export default GiftProductList;
